module.exports = __webpack_public_path__ + "img/sdgs_header.ca5c043f.png";